import React, { useState } from 'react';
import { Button, Modal, Text } from '@gjensidige/builders-components';

import './PropertyDataModal.scss';

interface ProperyDataModalProps {
  imageSrc: string;
  message: string;
  btnActionLabel: string;
}
export const PropertyDataModal: React.FC<ProperyDataModalProps> = ({
  imageSrc,
  message,
  btnActionLabel
}: ProperyDataModalProps) => {
  const [isOpen, setIsOpen] = useState(true);
  const onModalClose = (event?: any) => {
    event.preventDefault();
    setIsOpen(!isOpen);
  };
  return (
    <Modal
      aria-label="Hämtat fastighetsinformation"
      className="property-data-modal"
      open={isOpen}
      strict={true}
      onClick={onModalClose}
      closeLabel="Stäng information"
      size="sm"
    >
      <div className="property-data-modal-wrapper mt-5">
        <div className="illustration-wrapper">
          <img src={imageSrc} alt="property-data-fetch-success-image" />
        </div>
        <div className="property-data-message-wrapper mt-md-5 mt-3">
          <Text size="body" className="property-data-success-message">
            {message}
          </Text>
        </div>
        <div className="property-modal-action-btn mt-md-5 mt-3">
          <Button
            onClick={onModalClose}
            tracking={true}
            className=""
            size="sm"
            variant="primary"
          >
            {btnActionLabel}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
